import { createSlice } from '@reduxjs/toolkit';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { SubscriptionChargeStatus } from '../../../app/constants';
import { updateSubscription, getParkitSubscriptions, pauseChargeSubscription, recreateSubscription } from '../../../api/parkitSubscriptionAPI';

export const subscriptionSlice = createSlice({
  name: 'parkitSubscription',
  initialState: {
    subscriptions: [],
    pagination: {},
    page: 0,
    rowsPerPage: 50,
    sort: 'desc',
    sortBy: 'nextBillingDate',
    selectedSubscription: null,
    selectedFilter: {
      chargeStatus: [SubscriptionChargeStatus.PENDING, SubscriptionChargeStatus.PAID, SubscriptionChargeStatus.PAUSE_CHARGE],
    },
    successMessage: "",
    errorMessage: "",
    confirmPauseChargeModalOpen: false,
    recreateSubscriptionModalOpen: false,
    filterModalOpen: false,
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSubscriptions: (state, action) => {
      state.subscriptions = action.payload;
    },
    setSelectedSubscription: (state, action) => {
      state.selectedSubscription = action.payload;
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    openConfirmPauseChargeModal: (state) => {
      state.confirmPauseChargeModalOpen = true;
    },
    closeConfirmPauseChargeModal: (state) => {
      state.confirmPauseChargeModalOpen = false;
    },
    openRecreateSubscriptionModal: (state) => {
      state.recreateSubscriptionModalOpen = true;
    },
    closeRecreateSubscriptionModal: (state) => {
      state.recreateSubscriptionModalOpen = false;
    },
    showFilterModal: (state, action) => {
      state.filterModalOpen = action.payload;
    }
  }
});

export const { setSort, setSortBy, setSelectedFilter, showFilterModal, openRecreateSubscriptionModal, closeRecreateSubscriptionModal, setSelectedSubscription, openConfirmPauseChargeModal, closeConfirmPauseChargeModal, setPage, setRowsPerPage, setPagination, setSubscriptions, setSuccessMessage, setErrorMessage } = subscriptionSlice.actions;

export const selectState = state => state.parkitSubscription;

export const handleGeSubscriptions = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    const { selectedFilter } = state.parkitSubscription;
    const chargeStatues = selectedFilter.chargeStatus.join(",");
    const response = await getParkitSubscriptions(state.parkitSubscription.page, state.parkitSubscription.rowsPerPage, state.parkitSubscription.sort, state.parkitSubscription.sortBy, chargeStatues);
    const { content, ...pagination } = response.data;

    dispatch(setPagination(pagination));
    dispatch(setSubscriptions(content));
  } catch (error) {
    dispatch(setErrorMessage(error.response?.data?.message ?? error.message));
    dispatch(setSubscriptions([]));
  } finally {
    dispatch(hideLoading());
  }
}

export const handlePauseCharge = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();
  try {
    await pauseChargeSubscription(state.parkitSubscription.selectedSubscription.id, state.parkitSubscription.selectedSubscription.walletId);
    dispatch(handleGeSubscriptions());
    dispatch(closeConfirmPauseChargeModal());
    dispatch(setSuccessMessage('Subscription pause charge requested successfully'));
  } catch (error) {
    dispatch(setErrorMessage(error.response?.data?.message ?? error.message));
  } finally {
    dispatch(hideLoading());
  }
}

export const handleRecreateSubcription = (payload) => async (dispatch) => {
  dispatch(showLoading());
  try {
    await recreateSubscription(payload);
    dispatch(handleGeSubscriptions());
    dispatch(closeRecreateSubscriptionModal());
    dispatch(setSuccessMessage('Recreate subscription requested successfully'));
  } catch (error) {
    dispatch(setErrorMessage(error.response?.data?.message ?? error.message));
  } finally {
    dispatch(hideLoading());
  }
}

export const handleEditSubscription = (payload) => async (dispatch) => {
  dispatch(showLoading());
  try {
    await updateSubscription(payload.id, payload);
    dispatch(handleGeSubscriptions());
    dispatch(setSuccessMessage('Successfully update subscription'));
  } catch (error) {
    dispatch(setErrorMessage(error.response?.data?.message ?? error.message));
  } finally {
    dispatch(hideLoading());
  }
}

export default subscriptionSlice.reducer;